<div class="inner-item-wrapper">
  <div class="item-container">
      <h1>{{translationsService.translate('galis_js_dashboard_search')}}</h1>
      <div class="search-control">
          <div class="wrapper">
            <input [(ngModel)]="searchTerm" type="text" (keydown.enter)="dashboardSearch($event)" placeholder="{{translationsService.translate(customPlaceholder)}}" />
              <div class="search-selector">
                  <div class="dd-search dash" (click)="dashboardSearch($event)">
                      <p>{{translationsService.translate('galis_js_dashboard_search')}}</p>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>